var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6909 9.98047H8.30889C4.98311 9.98047 2.27686 12.6863 2.27686 16.0125V20H17.7229V16.0125C17.7229 12.6863 15.0167 9.98047 11.6909 9.98047ZM3.44873 18.8281V16.0125C3.44873 13.3324 5.6292 11.1523 8.30889 11.1523H11.6909C14.3706 11.1523 16.5511 13.3324 16.5511 16.0125V18.8281H3.44873Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 0C7.42803 0 5.33545 2.09258 5.33545 4.66445C5.33545 7.23633 7.42803 9.32891 9.9999 9.32891C12.5718 9.32891 14.6644 7.23633 14.6644 4.66445C14.6644 2.09258 12.5718 0 9.9999 0ZM9.9999 8.15703C8.07412 8.15703 6.50732 6.59024 6.50732 4.66445C6.50732 2.73867 8.07412 1.17188 9.9999 1.17188C11.9257 1.17188 13.4925 2.73867 13.4925 4.66445C13.4925 6.59024 11.9257 8.15703 9.9999 8.15703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.bd7afcfc8a3961e1003da0183abc77b6.svg";
export { ForwardRef as ReactComponent };